import log from "loglevel";

// Configure logger based on environment
const isProduction = process.env.ZAI_ENV === "production";
const appEnv = process.env.APP_ENV || "development";

// Set log level based on environment
if (isProduction) {
  log.setLevel("silent"); // Disable all logs in production
} else if (appEnv === "uat" || appEnv === "staging") {
  log.setLevel("info"); // Show info, warn, and error in UAT/staging
} else {
  log.setLevel("trace"); // Show all logs in development
}

// Create custom logger with prefixes
export const logger = {
  pwa: {
    log: (...args: any[]) => log.info("[PWA]", ...args),
    info: (...args: any[]) => log.info("[PWA]", ...args),
    warn: (...args: any[]) => log.warn("[PWA]", ...args),
    error: (...args: any[]) => log.error("[PWA]", ...args),
  },
  sw: {
    log: (...args: any[]) => log.info("[SW]", ...args),
    info: (...args: any[]) => log.info("[SW]", ...args),
    warn: (...args: any[]) => log.warn("[SW]", ...args),
    error: (...args: any[]) => log.error("[SW]", ...args),
  },
  debug: (...args: any[]) => log.debug(...args),
  info: (...args: any[]) => log.info(...args),
  warn: (...args: any[]) => log.warn(...args),
  error: (...args: any[]) => log.error(...args),
};

// For browser debugging (can be called from console)
if (typeof window !== "undefined") {
  (window as any).enablePWALogs = () => {
    log.setLevel("trace");
    logger.info("PWA logs enabled");
  };

  (window as any).disablePWALogs = () => {
    logger.info("PWA logs disabled");
    log.setLevel("silent");
  };

  (window as any).getLogLevel = () => {
    return log.getLevel();
  };
}

export default logger;
